import { defineComponent, IOmniaShell, shell } from "../../omnia"
import { ISoilService } from "../../types"
import { MapAllocationContext } from "./context"
import { IGlobalAllocationsBindingModel, IGlobalAnalysisBindingModel } from "./types"

/// <reference path="context.ts"/>

export abstract class GlobalMapPopupCtrl extends shell.Dialog {

    public static create(): ng.IDirective {

        return defineComponent(GlobalMapPopupCtrl, "app/soil/dashboard/global-map/global-map-popup.html");

    };

    static $inject = ["$scope", "$q", "OmniaSoilService", "OmniaShell"];

    public context: MapAllocationContext;

    constructor($scope: ng.IScope, private $q: ng.IQService, protected svc: ISoilService, shell: IOmniaShell) {
        super($scope, shell);
    }

    $onInit() {

        this.svc
            .refresh()
            .then(() => {

                var queries: any = {
                    analysisLayers: this.svc.getSoilAnalysisLayers(true),
                    soilsLayers: this.svc.getSoilTypeLayers(true)
                };

                this.$q.all(queries).then((results: any) => {
                    this.context = new MapAllocationContext(this.svc, results.analysisLayers, results.soilsLayers);
                });
            });

    }

    get ready(): boolean {
        return !!this.context;
    }

    get changes(): boolean {
        return this.context && this.context.analysis
            ? this.context.analysis.filter(a => a.allocationsChanged()).length > 0
            : false;
    }

    private canCommit(): boolean {
        return this.changes && !!this.context && !this.context.selectedAnalysis;
    }

    private commit() {

        var model = <IGlobalAllocationsBindingModel>{
            YearId: this.svc.yearId,
            AnalysisType: this.context.analysisType,
            Analysis: this.context.analysis.filter(a => a.allocationsChanged()).map(a => {
                return <IGlobalAnalysisBindingModel>{
                    AnalysisId: a.getAnalysisId(),
                    Allocations: a.getAllocationModels()
                }
            })
        }

        this.svc.saveGlobalAnalysisAlloc(model).then(r => this.close(1));

    }

}
